import React, { useState } from 'react';
import RoomIcon from './RoomIcon';
import './HomePage.css';

const API = process.env.REACT_APP_API_URL || '';

export default function HomePage({ navigate }) {
  const [videoUrl, setVideoUrl] = useState('');
  const [linkFocused, setLinkFocused] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleCreate = async (e) => {
    e.preventDefault();
    if (!videoUrl.trim()) {
      setError('Вставьте ссылку на видео');
      return;
    }
    
    // Проверяем поддерживаемые платформы
    const isRutube = videoUrl.includes('rutube.ru/video/');
    const isYouTube = videoUrl.includes('youtube.com/watch') || 
                     videoUrl.includes('youtu.be/') || 
                     videoUrl.includes('youtube.com/embed') ||
                     videoUrl.includes('youtube.com/shorts');
    
    if (!isRutube && !isYouTube) {
      setError('Поддерживаются ссылки Rutube (rutube.ru/video/...) и YouTube');
      return;
    }
    
    setLoading(true);
    setError('');
    try {
      const res = await fetch(`${API}/api/rooms`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ videoUrl }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Ошибка создания комнаты');
      navigate(`/room/${data.roomId}`);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={`home-page ${videoUrl.trim() || linkFocused ? 'home-page--connecting' : ''}`}>
      <div className="home-cinema" aria-hidden="true">
        <div className="home-cinema-grain" />
        <div className="home-cinema-screen">
          <div className="home-cinema-orbit home-cinema-orbit--one" />
          <div className="home-cinema-orbit home-cinema-orbit--two" />
          <div className="home-cinema-connection" />
          <div className="home-cinema-center">▶</div>
        </div>
        <div className="home-cinema-beam home-cinema-beam--left" />
        <div className="home-cinema-beam home-cinema-beam--right" />
      </div>

      <div className="home-content">
        <header className="home-header">
          <div className="home-logo">
            <span className="logo-icon">▶</span>
            <span className="logo-text">WATCHPARTY</span>
          </div>
          <div className="home-eyebrow"><span /> КИНО НАЧИНАЕТСЯ ЗДЕСЬ</div>
          <h1 className="home-title">Один экран.<br /><em>Любое расстояние.</em></h1>
          <p className="home-subtitle">Вставьте ссылку, пригласите друзей и смотрите вместе — будто вы рядом.</p>
          <div className="home-storyline" aria-hidden="true">
            <span>01 / ВЫБЕРИТЕ ВИДЕО</span>
            <span className="home-storyline-track" />
            <span>02 / СМОТРИТЕ ВМЕСТЕ</span>
          </div>
        </header>

        <div className="home-card">
          <div className="home-card-label"><span className="home-live-dot" /> НОВЫЙ СЕАНС</div>
          <h2>Что смотрим сегодня?</h2>
          <p className="home-card-description">Комната появится сразу после выбора видео.</p>
          <form onSubmit={handleCreate} className="home-form">
            <div className="form-group">
              <label className="form-label" htmlFor="video-url">Ссылка на видео</label>
              <input
                id="video-url"
                className="form-input"
                type="text"
                inputMode="url"
                placeholder="https://rutube.ru/video/... или https://youtube.com/watch?v=..."
                value={videoUrl}
                onChange={e => { setVideoUrl(e.target.value); setError(''); }}
                onFocus={() => setLinkFocused(true)}
                onBlur={() => setLinkFocused(false)}
              />
            </div>
            <div className="platform-hint">
              <span className="platform-badge rutube">Rutube</span>
              <span className="platform-badge youtube">YouTube</span>
            </div>
            {error && <div className="form-error">{error}</div>}
            <button className="btn-create" type="submit" disabled={loading}>
              {loading ? (
                <span className="btn-loading"><span className="dot" /><span className="dot" /><span className="dot" /></span>
              ) : (
                <>
                  <span className="btn-icon">▶</span>
                  Создать комнату
                </>
              )}
            </button>
          </form>
          <div className="home-card-footer"><span>БЕЗ РЕГИСТРАЦИИ</span><span>ПРИГЛАШЕНИЕ ПО ССЫЛКЕ</span></div>
        </div>

        <div className="home-features">
          <div className="feature">
            <span className="feature-icon"><RoomIcon name="bolt" size={15} /></span>
            <span>Мгновенная синхронизация</span>
          </div>
          <div className="feature">
            <span className="feature-icon"><RoomIcon name="chat" size={15} /></span>
            <span>Текстовый чат</span>
          </div>
          <div className="feature">
            <span className="feature-icon"><RoomIcon name="mic" size={15} /></span>
            <span>Голосовой чат</span>
          </div>
        </div>
      </div>
    </div>
  );
}
